
import React from 'react';

const Cross = (): JSX.Element => {
    return (
        <path fillRule="evenodd" clipRule="evenodd" d="M1.75735 1.75737C4.10049 -0.585782 7.89948 -0.585791 10.2426 1.75735L30.0001 21.5147L49.7575 1.75736C52.1006 -0.585786 55.8996 -0.585786 58.2428 1.75736C60.5859 4.10051 60.5859 7.89949 58.2428 10.2426L38.4854 30L58.2428 49.7574C60.5859 52.1005 60.5859 55.8995 58.2428 58.2426C55.8996 60.5858 52.1006 60.5858 49.7575 58.2426L30.0001 38.4853L10.2426 58.2427C7.89948 60.5858 4.10049 60.5858 1.75735 58.2426C-0.585791 55.8995 -0.585782 52.1005 1.75737 49.7573L21.5148 30L1.75737 10.2427C-0.585782 7.89951 -0.585791 4.10052 1.75735 1.75737Z" />
    );
};

export default Cross;
